import "@/filters";
import "@/plugins/leaflet";
import "core-js/es/object";
import "core-js/es/typed-array/from";
import "isomorphic-fetch";
import Vue from "vue";
import App from "./App.vue";
import i18n from "./i18n";
import "./plugins/amplify";
import "./plugins/apexcharts";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";

// Vue.config.devtools = true;
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App)
}).$mount("#app");
